<template>
  <b-card-code title="All Categories " no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- sorting  -->

        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <div class="d-flex flex-wrap align-items-center">
          <EntityExcelToolbar entity="categories" class="mr-1 mb-1" @imported="getCategories" />
          <addNewCategory />
        </div>
      </div>
    </b-card-body>

    <b-table
      v-if="Categories.length > 0"
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :items="Categories"
      :fields="fields"
    >
      <template #cell(image)="data">
        <b-avatar :src="data.item.image" />
        <!-- {{ data.title }} -->
      </template>
      <template #cell(Action)="data">
        <!-- <p>
          Using v-html directive: <span v-html="data.item.description"></span>
        </p> -->

        <span>
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <!-- <b-dropdown-item @clieck="">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item> -->
              <duplicateCategory :item="data.item" />
              <editCategory :Category="data.item" />
              <!-- <b-dropdown-item>
                <feather-icon icon="TrashIcon" class="mr-50 text-danger" />
                <span class="mr-50 text-danger">Delete</span>
              </b-dropdown-item> -->
              <deleteCategory
                @deleteCategoryFromlist="deleteCategoryFromlist"
                :id="data.item._id"
              />
            </b-dropdown>
          </span>
        </span>
        <!-- {{ data }} -->
        <!-- <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge> -->
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <!-- <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group> -->

      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="prams.limit"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <template #code>
      <!-- {{ codeKitchenSink }} -->
    </template>
  </b-card-code>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
} from "bootstrap-vue";
// import { codeKitchenSink } from "./code";
import CategoriesApi from "@/apiServices/categoriesApi";
import deleteCategory from "@/views/categories pages/delete.vue";
import editCategory from "@/views/categories pages/edit.vue";
import addNewCategory from "@/views/categories pages/add.vue";
import duplicateCategory from "@/views/categories pages/duplicate.vue";
import EntityExcelToolbar from "@/components/EntityExcelToolbar.vue";

export default {
  components: {
    EntityExcelToolbar,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    deleteCategory,
    addNewCategory,
    editCategory,
    duplicateCategory,
  },
  data() {
    return {
      prams: {
        sort: "-createdAt",
        page: 1,
        limit: 5,
        name: "",
      },
      options: ["video", "pdf", "powerpoint"],

      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      filter: "",
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "image",
          label: "image",
        },
        { key: "name", label: "name" },

        "Action",
      ],
      /* eslint-disable global-require */
      Categories: [],
      /* eslint-disable global-require */
      status: [],
      //   codeKitchenSink,
    };
  },
  created() {
    this.getCategories();
  },
  computed: {},
  mounted() {
    // this.totalRows = this.items.length;
  },
  watch: {
    currentPage() {
      this.prams.page = this.currentPage;
      this.getCategories();
    },
    filter() {
      this.prams.page = this.currentPage;
      this.prams.name = this.filter;
      this.getCategories();
    },
  },
  methods: {
    deleteCategoryFromlist(id) {
      console.log("hi from parent " + id + "******" + this.Categories.length);
      this.Categories = this.Categories.filter(function (obj) {
        return obj._id != id;
      });
      console.log("hi ******" + this.Categories.length);
    },
    getCategories() {
      if (this.filter == "") {
        delete this.prams.name;
      }
      CategoriesApi.getCategories(this.prams).then((response) => {
        this.Categories = [];
        if (response.data) {
          this.Categories = response.data;
          this.currentPage = response.paginationResult?.currentPage;
          this.totalRows =
            response.paginationResult?.numberOfPages * this.prams.limit;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "get All Categories",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      //   this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
